import React, { createContext, useContext, useState } from "react";

const CityContext = createContext(null);

export function CityProvider({ children }) {
  const [selectedCity, setSelectedCityState] = useState(() => {
    try { return localStorage.getItem("apnajob_city") || ""; } catch { return ""; }
  });

  const setSelectedCity = (city) => {
    setSelectedCityState(city);
    try {
      if (city) localStorage.setItem("apnajob_city", city);
      else localStorage.removeItem("apnajob_city");
    } catch {}
  };

  return (
    <CityContext.Provider value={{ selectedCity, setSelectedCity }}>
      {children}
    </CityContext.Provider>
  );
}

export function useCity() {
  const ctx = useContext(CityContext);
  // Safe fallback — won't crash if provider is missing
  if (!ctx) {
    console.warn("useCity: CityProvider not found in tree. Returning no-op fallback.");
    return { selectedCity: "", setSelectedCity: () => {} };
  }
  return ctx;
}